module.exports = __webpack_public_path__ + "7b6f84817941846e162f2fcb08a7d57e.pdf";